
import { dbManager } from './db_manager';

export const bookService = {
    async getBooks(userId: string) {
        return dbManager.from('books', userId).select();
    },

    async saveBook(userId: string, bookData: any) {
        return dbManager.from('books', userId).upsert({
            user_id: userId,
            ...bookData,
            updated_at: new Date().toISOString()
        });
    },

    async deleteBook(userId: string, bookId: string) {
        return dbManager.from('books', userId).delete(bookId);
    },

    async toggleFavorite(userId: string, bookId: string, isFavorite: boolean) {
        return dbManager.from('books', userId).upsert({
            id: bookId,
            user_id: userId,
            is_favorite: isFavorite,
            updated_at: new Date().toISOString()
        });
    },

    async updateDisplayOrder(userId: string, bookId: string, order: number) {
        return dbManager.from('books', userId).upsert({
            id: bookId,
            user_id: userId,
            display_order: order,
            updated_at: new Date().toISOString()
        });
    },

    async updateBookFields(userId: string, bookId: string, fields: any) {
        return dbManager.from('books', userId).upsert({
            id: bookId,
            user_id: userId,
            ...fields,
            updated_at: new Date().toISOString()
        });
    }
};
